export const isGooglebotMobile = ua =>
  /Mobile.*Googlebot.*http:\/\/www.google.com\/bot.html/.test(ua);

export const isGooglebotDesktop = ua =>
  !isGooglebotMobile(ua) &&
  /Googlebot.*http:\/\/www.google.com\/bot.html/.test(ua);

export const isGooglebot = ua =>
  isGooglebotMobile(ua) || isGooglebotDesktop(ua);
